<template>
	<div class="buying">
		<span class="quantity_control" v-if="1==2">
			<button type="button" v-on:click="adjustQty(-1)" class="decrease"><i class="fal fa-fw fa-minus"></i></button>
			<input type="number" min="1" max="100" step="1" name="quantity" class="quantity" v-model="quantity">
			<button type="button" v-on:click="adjustQty(+1)" class="increase"><i class="fal fa-fw fa-plus"></i></button>
		</span>
		<button type="submit" class="button solid upper green" v-on:click.prevent="addToBasket()" v-if="productpage=='false'">Add To Basket</button>
		<button type="submit" class="button medium solid upper green" v-on:click.prevent="addToBasket()" v-else>Add Sample To Basket</button>
	</div>
</template>
<script>
import debounce from '../debounce.js';
import { mapGetters, mapActions } from 'vuex';

export default {

	directives: {debounce},

	props: [
		'product',
		'productpage'
	],
  
	data: () => {
		return {
			quantity: 1,
			max_quantity: 10,
			working_variation: {}
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
		for (var key in this.product.variations) {
			if(this.product.variations[key]['is_sample'] == 1) {
				this.working_variation = this.product.variations[key];
			}
		}
	},

	methods: {
		// Map the Methods from the State Module
		...mapActions(['minicartRefresh']),

		adjustQty: function(qty) {
			var newqty = parseInt(this.quantity) + qty;
			if (newqty > 0) {
				if (newqty > this.max_quantity) {
					newqty = this.max_quantity;
				}
				this.quantity = newqty;
			}
		},

		addToBasket: function() {
			//if( this.quantity < 1 ) {
			//	alert('You must set a quantity');
			//	return false;
			//}

			axios.post('/box/basket/add', {
				Model_Type: '\\App\\Variation',
				Model_Id: this.working_variation.id,
				Quantity: 1,
				FreeTypeAttributes: ''

			}).then((response) => {
				this.$store.commit('updateMinicartRefreshStatus', true);
				this.popup(this.product.name);
			});
		},

		popup: function(item) {
			if(this.productpage=='true') {
				var content = '<b>Sample</b> added to your basket.';
			}else{
				var content = '<b>' + item + '</b> added to your basket.';
			}
			$.alert({
				title: 'Great!',
				content: content,
				buttons: {
					Continue: {
						text: 'Continue Shopping',
					},
					Basket: {
						text: 'View Basket',
						btnClass: 'btn-green',
						action: function () {
							window.location.href = '/basket'
						}
					}
				}
			});

		},



	}
};
</script>